import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

const Drag = ({ elementId, children, defaultPosition }) => {
  const leftPosition = defaultPosition?.left ?? 'unset';
  const bottomPosition = defaultPosition?.bottom ?? 'unset';

  useEffect(() => {
    const draggable = document.getElementById(elementId);

    let offsetX = 0,
      offsetY = 0;
    let isDragging = false;

    draggable.addEventListener('mousedown', (e) => {
      isDragging = true;
      offsetX = e.clientX - draggable.offsetLeft;
      offsetY = e.clientY - draggable.offsetTop;
      draggable.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', (e) => {
      if (isDragging) {
        draggable.style.left = `${e.clientX - offsetX}px`;
        draggable.style.top = `${e.clientY - offsetY}px`;
      }
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
      draggable.style.cursor = 'grab';
    });
  }, [elementId]);

  return (
    <Box id={elementId} position={'fixed'} zIndex={9999} left={leftPosition} bottom={bottomPosition}>
      {children}
    </Box>
  );
};

export default Drag;
